import { UNIT_AVAILABILITY_LABELS, type UnitAvailability } from '@lia/contracts';
import * as React from 'react';
import { StatusBadge } from '../primitives/badge.js';
import { UNIT_AVAILABILITY_TONE } from './status.js';

export interface InventoryStatusProps {
  availability: UnitAvailability;
  /** Optional unit reference shown before the status, e.g. "Depto. 1204". */
  unitLabel?: string;
  className?: string;
}

/** Unit availability badge (icon + text). */
export const InventoryStatus = React.forwardRef<HTMLSpanElement, InventoryStatusProps>(function InventoryStatus({ availability, unitLabel, className }, ref) {
  return (
    <StatusBadge ref={ref} tone={UNIT_AVAILABILITY_TONE[availability]} className={className}>
      {unitLabel ? `${unitLabel} · ` : ''}
      {UNIT_AVAILABILITY_LABELS[availability]}
    </StatusBadge>
  );
});
